import React, {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import {useAuth} from '../../../modules/auth'
import {getUserSalaryById} from '../../../../api/SalaryAPI'

interface SalaryData {
  date: string
  annualPackage: string
}

const Salary = () => {
  const [userData, setUserData] = useState<SalaryData[]>([])
  const {currentUser} = useAuth()
  const {id} = useParams()

  useEffect(() => {
    let mounted = true

    const fetchData = async () => {
      try {
        const data: SalaryData[] = await getUserSalaryById(id ?? currentUser?.id, currentUser)
        if (mounted) {
          setUserData(data || [])
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }

    fetchData()

    return () => {
      mounted = false
    }
  }, [id, currentUser])

  // Group salary data by month
  const groupedData = userData.reduce((acc, curr) => {
    const monthYear = new Date(curr.date).toLocaleDateString('en-US', {
      month: 'long',
      year: 'numeric',
    })
    if (!acc[monthYear]) {
      acc[monthYear] = []
    }
    acc[monthYear].push(curr)
    return acc
  }, {})

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div
          className='card-header border-0 cursor-pointer'
          role='button'
          data-bs-toggle='collapse'
          data-bs-target='#kt_account_signin_method'
        >
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Salary</h3>
          </div>
        </div>

        <div id='kt_account_signin_method' className='collapse show'>
          <div className='card-body border-top p-9'>
            {Object.entries(groupedData).map(([monthYear, data]) => (
              <div key={monthYear}>
                <div className='fs-6 fw-bolder mb-1'>{monthYear}</div>
                {userData.map((item, index) => (
                  <div
                    key={index}
                    className='d-flex flex-wrap align-items-center justify-content-between'
                  >
                    <div>{item.date}</div>
                    <div>{item.annualPackage}</div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default Salary
